import Vue from 'vue';
import {getModule} from 'vuex-module-decorators';

import {ILogger, LogLevel} from '@/utils/ILogger';

import {Level, Notification} from '@/model/Notification';

import {NotificationStore} from '@/store/Notification.store';

export class Notify {

  public static Success(logger: ILogger, message: string, details: string[] = []) {
    Notify.Notify(logger, Level.Success, message, details);
  }

  public static Info(logger: ILogger, message: string, details: string[] = []) {
    Notify.Notify(logger, Level.Info, message, details);
  }

  public static Warn(logger: ILogger, message: string, error: any = null, details: string[] = []) {
    Notify.Notify(logger, Level.Warn, message, details, error);
  }

  public static Error(logger: ILogger, message: string, error: any = null, details: string[] = []) {
    Notify.Notify(logger, Level.Error, message, details, error);
  }

  public static Notify(logger: ILogger, level: Level, message: string, details: string[] = [], error: any = null) {

    if (error != null && error.hasOwnProperty('message')) {
      logger.log(LogLevel.ERROR, message, error, error.stack);
    }

    const store: NotificationStore = getModule(NotificationStore, Vue.prototype.$store);

    const notification = new Notification(message, level, undefined, details, error);

    store.addNotification(notification);
  }
}

